import styled from '@emotion/styled';

export const ImageItem = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    max-width: 100%;
    user-select: none;
    pointer-events: none;
  }

  & img, & div {
    transition: all .2s ease;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 ${({ theme }) => theme.spacing(2)};
`;
